import React from 'react';
import { Route } from 'react-router-dom';
import Suspense from '../components/loading/suspense';
import { PAGES } from '../constants/configuration';

const Configuration = React.lazy(() => import('../components/configurations'));
//const Home = React.lazy(() => import('../components/home'));
const Calendar = React.lazy(() => import('../components/Calendar'));
const FlightReport = React.lazy(() => import('../components/FlightReport'));
const FlightRequests = React.lazy(() => import('../components/FlightRequest'));
const FlightRequestDetails = React.lazy(() => import('../components/FlightRequestDetails'));
const FlightRequestList = React.lazy(() => import('../components/FlightRequestList'));
const FlightRequestOffer = React.lazy(() => import('../components/FlightRequestOffer'));
const SystemRules = React.lazy(() => import('../components/Rules'));
const RplDateTimeConstraints = React.lazy(() => import('../components/Rules/RplDateTimeConstraints'));
const Terminals = React.lazy(() => import('../components/Rules/Terminals'));
const TimeShare = React.lazy(() => import('../components/Rules/TimeShare'));
const CityShare = React.lazy(() => import('../components/Rules/CityShare'));
const NightStay = React.lazy(() => import('../components/Rules/NightStay'));
const FlightRquestCancellation = React.lazy(() => import('../components/FlightCancellation'));
const FlightRquestReEstablish = React.lazy(() => import('../components/FlightRestablish'));
const FlightTimeChange = React.lazy(() => import('../components/FlightTimeChange'));
const FlightRequestReport = React.lazy(() => import('../components/FlightRequestReport'));
const FlightRequestReportList = React.lazy(() => import('../components/FlightRequestReport/ReportList'));
const RplsList = React.lazy(() => import('../components/Rpl'));
const Users = React.lazy(() => import('../components/security/user'));

const LazyLoad = (Component: any) => (
    <Suspense>
        <Component />
    </Suspense>
);

export default [
    <Route exact path={PAGES.CONFIGURATION} render={() => LazyLoad(Configuration)} />,
    <Route exact path={PAGES.CALENDAR} render={() => LazyLoad(Calendar)} />,
    <Route exact path={`${PAGES.REPORT}`} render={() => LazyLoad(FlightReport)} />,
    <Route exact path={`${PAGES.CONTINUE_REQUEST}`} render={() => LazyLoad(FlightRequests)} />,
    <Route exact path={PAGES.NEW_REQUEST} render={() => LazyLoad(FlightRequests)} />,
    <Route exact path={`${PAGES.REQUEST_DETAILS}`} render={() => LazyLoad(FlightRequestDetails)} />,
    <Route exact path={`${PAGES.REQUEST_OFFER}`} render={() => LazyLoad(FlightRequestOffer)} />,
    <Route exact path={PAGES.REQUESTS_LIST} render={() => LazyLoad(FlightRequestList)} />,
    <Route exact path={PAGES.SYSTEM_RULES} render={() => LazyLoad(SystemRules)} />,
    <Route exact path={PAGES.RPL_CONSTRAINTS} render={() => LazyLoad(RplDateTimeConstraints)} />,
    <Route exact path={PAGES.TERMINALS} render={() => LazyLoad(Terminals)} />,
    <Route exact path={PAGES.TIME_SHARE} render={() => LazyLoad(TimeShare)} />,
    <Route exact path={PAGES.CITY_SHARE} render={() => LazyLoad(CityShare)} />,
    <Route exact path={PAGES.NIGHT_STAY_SHARE} render={() => LazyLoad(NightStay)} />,
    <Route exact path={PAGES.REQUEST_CANCEL} render={() => LazyLoad(FlightRquestCancellation)} />,
    <Route exact path={PAGES.REQUEST_REESTABLISH} render={() => LazyLoad(FlightRquestReEstablish)} />,
    <Route exact path={PAGES.TIME_CHANGE} render={() => LazyLoad(FlightTimeChange)} />,
    <Route exact path={PAGES.FLIGHT_REQUEST_REPORT} render={() => LazyLoad(FlightRequestReport)} />,
    <Route exact path={PAGES.FLIGHT_REQUEST_REPORT_LIST} render={() => LazyLoad(FlightRequestReportList)} />,
    <Route exact path={PAGES.RPL_LIST} render={() => LazyLoad(RplsList)} />,
    <Route exact path={PAGES.USERS} render={() => LazyLoad(Users)} />,
];
